<h2 mat-dialog-title>Manager Authorization</h2>
<mat-dialog-content>
  <div class="d-flex flex-column gap-3 pt-2">
    <div class="alert alert-danger mb-0" *ngIf="errorMessage">
      <i class="fa fa-exclamation-circle me-2"></i>{{ errorMessage }}
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Username</mat-label>
      <input matInput [(ngModel)]="username" [disabled]="loading" (keyup.enter)="submit()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Password</mat-label>
      <input matInput [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" [disabled]="loading" (keyup.enter)="submit()">
      <button mat-icon-button matSuffix (click)="togglePasswordVisibility()">
        <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <!-- Remark field -->
    <mat-form-field appearance="outline" class="w-100" *ngIf="requireRemark">
      <mat-label>Remark / Reason</mat-label>
      <textarea matInput [(ngModel)]="remark" rows="3"></textarea>
    </mat-form-field>

    <!-- NFC hint -->
    <div *ngIf="nfcSupported" class="nfc-hint">
      <div *ngIf="nfcStatus === 'scanning'" class="d-flex align-items-center justify-content-center text-muted small">
        <mat-icon class="nfc-pulse-icon me-1">nfc</mat-icon>
        <span>NFC Ready — tap manager card on reader</span>
      </div>
      <div *ngIf="nfcStatus === 'verifying'" class="d-flex align-items-center justify-content-center text-muted small">
        <i class="fa fa-spinner fa-spin me-2"></i>
        <span>Verifying NFC card...</span>
      </div>
      <div *ngIf="nfcStatus === 'success'" class="d-flex align-items-center justify-content-center text-success small">
        <i class="fa fa-check-circle me-1"></i>
        <span>Authorized — {{ nfcResult?.username }}</span>
      </div>
      <div *ngIf="nfcStatus === 'error'" class="d-flex align-items-center justify-content-center small">
        <span class="text-danger me-2"><i class="fa fa-exclamation-circle me-1"></i>{{ nfcErrorMessage }}</span>
        <a class="text-primary" style="cursor: pointer;" (click)="retryNfc()">Retry</a>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="p-3">
  <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
  <button mat-raised-button color="primary"
    *ngIf="!nfcAuthenticated"
    (click)="submit()"
    [disabled]="loading || (requireRemark && !remark)">
    <span *ngIf="!loading">Verify</span>
    <span *ngIf="loading"><i class="fa fa-spinner fa-spin me-2"></i>Verifying...</span>
  </button>
  <button mat-raised-button color="primary"
    *ngIf="nfcAuthenticated && requireRemark"
    (click)="submitNfcRemark()"
    [disabled]="!remark">
    Submit
  </button>
</mat-dialog-actions>
